import { CardBaseComponent } from '@/components/base/card-base/card-base.component';
import { DocSummaryCardComponent } from '@/components/doc-summary-card/doc-summary-card.component';
import { DateFormatPipe } from '@/extensions/datePipe';
import { UserHelper } from '@/helpers/user.helper';
import { AlertService } from '@/services/alert.service';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {
  PropertiesBookletService,
  PropertyBooklet,
  PropertyBookletStatus,
  PropertyBookletType,
  RealProperty
} from '@eemo/api-client';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-property-booklet-card',
  standalone: true,
  imports: [
    CardBaseComponent,
    NgIf,
    NgTemplateOutlet,
    MatIconModule,
    DateFormatPipe,
    TranslateModule,
    MatButtonModule,
    DocSummaryCardComponent
  ],
  templateUrl: './property-booklet-card.component.html',
  styleUrl: './property-booklet-card.component.scss'
})
export class PropertyBookletCardComponent implements OnInit, OnDestroy {
  @Input() prop: RealProperty;
  @Input() booklet: PropertyBooklet;
  @Output() updateBookletClicked = new EventEmitter<PropertyBooklet>();
  @Output() deleteBookletClicked = new EventEmitter<PropertyBooklet>();

  deleteSub = new Subscription();
  isValidated = false;
  isValidating = false;
  isRenovation = false;
  workTypesDisplay = '';
  title = 'CIL - ';
  canUpdateProperty = false;

  constructor(
    private dialog: MatDialog,
    private bookletService: PropertiesBookletService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private userHelper: UserHelper
  ) {}

  ngOnInit(): void {
    this.canUpdateProperty = this.userHelper.canUpdateProperty(this.prop);
    this.isValidated = this.booklet.status === PropertyBookletStatus.VALIDATED;
    this.isValidating = this.booklet.status === PropertyBookletStatus.GENERATING;
    this.isRenovation = this.booklet.type === PropertyBookletType.RENOVATION;
    if (this.isValidated) {
      this.title += 'validé';
    } else {
      this.title += 'en cours';
    }
    if (this.isRenovation) {
      const types = [];
      this.booklet.renovationWorkTypes.forEach((t) =>
        types.push(this.translateService.instant('enum.PropertyBookletRenovationWorkType.' + t))
      );
      this.workTypesDisplay = types.join(', ');
    }
  }

  ngOnDestroy(): void {
    this.deleteSub.unsubscribe();
  }

  updateBooklet() {
    this.updateBookletClicked.emit(this.booklet);
  }

  deleteBooklet() {
    this.deleteBookletClicked.emit(this.booklet);
  }
}
